import DictionaryApiService from "../../../admin/system/integrate/DictionaryApiService";

async function isDictionaryWord(word, language = "english") {
    try {
        const def = await DictionaryApiService.getWordDefinition(word, language);
        const entry = Array.isArray(def) ? def[0] : def;
        if (!entry) return false;
        if (Array.isArray(entry.meanings) && entry.meanings.length > 0) return true;
        return Boolean(entry.word);
    } catch {
        return false;
    }
}

async function isBannedWord(word, language = "english") {
    try {
        const result = await DictionaryApiService.checkBannedWords([word], language, false);
        const banned = result?.bannedWords;
        if (!Array.isArray(banned)) return false;
        const needle = String(word || "").toLowerCase();
        return banned.some((item) => {
            const value = typeof item === "string" ? item : (item?.word || "");
            return String(value).toLowerCase() === needle;
        });
    } catch {
        return false;
    }
}

/** Valid bonus word: in dictionary, not banned, length ≥ 3. */
export async function validateBonusWord(word, language = "english") {
    const trimmed = String(word || "").trim();
    if (trimmed.length < 3) return { ok: false, reason: "short" };
    const [inDict, banned] = await Promise.all([
        isDictionaryWord(trimmed, language),
        isBannedWord(trimmed, language),
    ]);
    if (banned) return { ok: false, reason: "banned" };
    if (!inDict) return { ok: false, reason: "unknown" };
    return { ok: true, reason: "ok" };
}
